import React, { Component } from "react";
import Form from "../form";
import moment from "moment";
import { compose } from "redux";
import { withUrlResource, withUrlResourceTimezone } from "common/utils";
import Resource from "common/components/Resource";
import client from "common/admin/client";
import resourceFactory from "common/admin/resourceFactory";
import { map } from "lodash";
import { AppValues } from "common/constants";
import { getItem, localStorage } from "common/storage";

class DuplicateNotification extends Component {
  state = {
    floors: [],
    companies: [],
    buildings: [],
  };

  async componentDidMount() {
    try {
      const floorsPromise = resourceFactory("floors").getAll({
        building_id: this.props.urlResource.id,
      });
      const companiesPromise = resourceFactory("companies").getAll({
        building_id: this.props.urlResource.id,
      });
      const buildingsPromise = resourceFactory(
        `buildings/${this.props.urlResource.id}/admin`,
      ).getAll();

      const [floors, companies, buildings] = await Promise.all([
        floorsPromise,
        companiesPromise,
        buildingsPromise,
      ]);

      this.setState({ floors, companies, buildings });
    } catch (error) {
      console.error("Error fetching resources:", error);
    }
  }

  isValidUrl(string) {
    try {
      new URL(string);
      return true; // If no error is thrown, the URL is valid
    } catch (_) {
      return false; // If an error is thrown, the URL is invalid
    }
  }

  handleSubmit = async (values, form, cb = () => {}) => {
    const { target, isContest } = values;

    let url =
      target === "building"
        ? `buildings/${this.props.urlResource.id}/notifications/bulk`
        : `buildings/${this.props.urlResource.id}/notifications`;
    const { setSubmitting, setErrors, setStatus, resetForm } = form;
    const multilingual = getItem(localStorage, AppValues.multilingual) || false;

    try {
      const formData = await this.buildFormData(values, target, isContest);
      formData.append("multilingual", multilingual);
      await client.post(url, { body: formData });
      resetForm();
      cb();
      setStatus({ success: true });
      setStatus({ showSnackbar: true });
    } catch (e) {
      setErrors({ http: e.message });
    }
    setSubmitting(false);
  };

  buildFormData = async (values, target, isContest) => {
    const formData = new window.FormData();

    for (const key of Object.keys(values)) {
      if (key === "image") {
        if (values[key]) {
          if (values[key] instanceof File) {
            formData.append("image", values[key]); // Ensure image is properly appended
          } else if (this.isValidUrl(values[key])) {
            const imageFile = await this.urlToFile(values[key]);
            if (imageFile) {
              formData.append("image", imageFile);
            }
          }
        }
      } else if (key === "floors") {
        formData.append(
          key,
          target === "floor"
            ? [values[key]]
            : target === "building"
              ? map(this.floors, ({ id }) => String(id))
              : [],
        );
      } else if (key === "companies") {
        formData.append(key, target === "company" ? [values[key]] : []);
      } else if (key === "buildings") {
        formData.append(key, target === "building" ? values[key] : []);
      } else if (key === "available_at" || key === "available_until") {
        // Format date values to ISO 8601 format
        formData.append(key, new Date(values[key]).toISOString());
      } else if (key === "isContest") {
        // Format date values to boolean
        formData.append("is_contest", isContest);
      } else {
        formData.append(key, values[key]); // Append the other fields
      }
    }

    return formData;
  };

  urlToFile = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        return null;
      }
      const blob = await response.blob();
      const fileName = url.split("/").pop();
      return new File([blob], fileName, { type: blob.type });
    } catch (error) {
      return null;
    }
  };

  redirectToCreate = () => {
    this.props.history.push(
      `/${this.props.urlResource.singular}/${this.props.urlResource.id}/notifications/new`,
    );
  };

  render() {
    const { match, urlResource } = this.props;
    const { id: resourceId, plural: resourcePlural, timezone } = urlResource;
    const ishilo = localStorage.getItem("HILO") === "true";
    const lang = localStorage.getItem("i18nLang");
    const { floors, companies, buildings } = this.state;

    return (
      <Resource
        name={`${resourcePlural}/${resourceId}/notifications/${match.params.notificationId}`}
        queryParams={{}}
        render={(notification) => {
          return (
            <Form
              isDuplicate
              floors={floors}
              companies={companies}
              handleSubmit={this.handleSubmit}
              timezone={timezone}
              buildings={buildings}
              redirectToCreate={this.redirectToCreate}
              lang={lang}
              initialValues={{
                title: notification.title,
                rsvp_form_url: notification.rsvp_form_url ?? "",
                rsvp_button_text: notification.rsvp_button_text ?? "",
                description: notification.description,
                html_content: notification.html_content,
                image: notification.image,
                send_push_notification: notification.send_push_notification,
                target: notification.target,
                floors: notification.floors,
                companies: notification.companies,
                buildings: [urlResource.id],
                available_at: moment().add(5, "m").toDate(),
                available_until: moment().add(10, "m").toDate(),
                n_type: notification.n_type || "NOTIFICATION",
                ishilo,
                isContest: notification.is_contest || false,
              }}
            />
          );
        }}
      />
    );
  }
}

const enhanced = compose(withUrlResource, withUrlResourceTimezone);

export default enhanced(DuplicateNotification);
